<template>
  <div>
    <br />
    <b-row>
      <b-col class="text-left">
        <h5 class="font-weight-bold text-primary">Testimonials</h5>
      </b-col>
      <b-col class="text-right">
        <router-link :to="{name: 'createTestimonial'}">
          <b-button variant="primary">
            <img class="mr-2" src="@/assets/create-new.svg" alt />Create New
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <div>
      <br />
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        responsive
        show-empty
        :busy="loading"
        hover
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(status)="row">
          <p class="text-success text-capitalize" v-if="row.value == 'publish'">
            <i class="fas fa-check"></i>
            {{row.value}}
          </p>
          <p class="text-gray-400 text-capitalize" v-else-if="row.value == 'archive'">
            <i class="fas fa-check"></i>
            {{row.value}}
          </p>
        </template>

        <template v-slot:cell(image_video)="row">
          <b-img :src="row.value" width="70px" rounded="circle" alt="Circle image"></b-img>
        </template>
        <template v-slot:cell(no)="data">{{ data.index + 1 }}</template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editTestimonial', params: {id: item.id}}"
            class="text-dark"
          >
            <img class="mr-2" src="@/assets/ic-edit.svg" alt />
          </router-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img class="mr-2" src="@/assets/rectangle.svg" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Up Order" class="text-primary">
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link v-b-tooltip.hover title="Down Order" class="text-primary">
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="text-left px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainProps: {
        blank: true,
        blankColor: '#777',
        width: 50,
        height: 50,
        class: 'm1',
      },
      loading: true,
      errored: false,
      vuex: [],
      items: [],
      fields: [
        {
          key: 'no',
          label: 'No',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'job_title',
          label: 'Job Title',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'testimonial.id',
          label: 'Testimonial',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'image_video',
          label: 'Image',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          class: 'text-center',
        },
        { key: 'action', label: 'Action', class: 'text-center' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      customerShow: false,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store.dispatch('testimonialModule/getTestimonials', null, {
      root: true,
    });
  },
  created() {
    this.totalRows = this.items.length;
    this.$store.watch(
      state => state.testimonialModule.testimonial,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
  },
  mounted() {},
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('testimonialModule/delTestimonial', id);
          this.$swal('Deleted!', 'Your file has been deleted.', 'success');
        }
      });
    },
  },
};
</script>

<style>
</style>
